import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Reveal } from "./Reveal";

const CONTACTS = [
  {
    key: "email",
    testid: "contact-email-link",
    href: "mailto:geral@azoruniquehome.com",
    value: "geral@azoruniquehome.com",
  },
  {
    key: "whatsapp",
    testid: "contact-whatsapp-link",
    href: "https://wa.me/351916927419",
    value: "+351 916 927 419",
  },
  {
    key: "address",
    testid: "contact-address-link",
    href: "https://maps.google.com/?q=2.%C2%AA+Ch%C3%A3+das+Cruzinhas,+8+Feteiras,+A%C3%A7ores",
    value: null,
  },
];

export const Contact = () => {
  const { t } = useLanguage();

  return (
    <section id="contactos" className="border-t border-white/10 bg-surface/40 py-28 sm:py-36" data-testid="contact-section">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.35em] text-terracotta">
            {t.contact.eyebrow}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl font-medium leading-[1.1] tracking-tight text-sand sm:text-5xl lg:text-6xl" data-testid="contact-title">
            {t.contact.title}
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-mist sm:text-base">{t.contact.note}</p>
        </Reveal>

        <div className="mt-16">
          {CONTACTS.map((c, i) => (
            <Reveal key={c.key} delay={0.1 + i * 0.08} y={20}>
              <a
                href={c.href}
                target={c.key === "email" ? undefined : "_blank"}
                rel="noopener noreferrer"
                data-testid={c.testid}
                className="group flex items-center justify-between gap-6 border-t border-white/10 py-8 transition-colors last:border-b hover:bg-white/[0.02]"
              >
                <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-mist transition-colors group-hover:text-terracotta">
                  {t.contact[c.key]}
                </span>
                <span className="flex items-center gap-3 text-right font-display text-lg text-sand transition-colors group-hover:text-terracotta sm:text-2xl">
                  {c.key === "address" ? t.contact.addressValue : c.value}
                  <ArrowUpRight
                    size={20}
                    className="shrink-0 text-mist transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-terracotta"
                  />
                </span>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.3em] text-sand/40" data-testid="contact-legal">
            {t.contact.legal}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
